export default "__VITE_ASSET__b5a21d58__"